
import { Component, Vue } from "vue-property-decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import { Table } from "@common/src/utils/decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { formDownload } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const common_warranty = namespace("common_warranty");
const base = namespace("base");
const management = namespace("management");
@InjectFunction("emptyToLine", "appCode", "permitApp")
@Component
@Table("loadListData")
export default class Parts extends Vue {
  @common_warranty.Action queryRecordList;
  @common_warranty.Action restSendEmail;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @management.Action queryCountryInfoList;

  dayjs = dayjs;
  recordList = [];
  statusList = [];
  sourceList = [];
  get searchForm() {
    return this.appCode === "speedbiz"
      ? {
          warrantyCardGenerateTimeBegin: "",
          warrantyCardGenerateTimeEnd: "",
          warrantyStartTimeBegin: "",
          warrantyStartTimeEnd: "",
          tireNo: "",
          warrantyCardCodes: [],
          plateCode: "",
          customerName: "",
          customerMobile: "",
          customerMail: "",
          statusList: [],
          warrantySource: ""
        }
      : {
          storeCode: "",
          warrantyCardGenerateTimeBegin: "",
          warrantyCardGenerateTimeEnd: "",
          warrantyStartTimeBegin: "",
          warrantyStartTimeEnd: "",
          tireNo: "",
          warrantyCardNo: "",
          status: "",
          warrantySource: ""
        };
  }
  storeList: any = [];
  get searchList() {
    return [
      {
        if: this.appCode === "speedbiz-operation",
        label: t("v216_g.country"),
        type: "select",
        value: "",
        selectList: this.countryList,
        prop: "countryCode"
      },
      {
        if: this.appCode === "speedbiz-operation",
        label: t("staff.store"),
        type: "select-search",
        value: "",
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore
      },
      {
        label: t("v3_6_0.create-date"),
        type: "daterange",
        value: "",
        prop: "createTime"
      },
      {
        label: t("v3_6_0.purchase-date"),
        type: "daterange",
        value: "",
        prop: "purchaseTime"
      },
      {
        label: t("v3_6_0.tire-no"),
        type: "input",
        value: "",
        prop: "tireNo"
      },
      {
        label: t("v3_7_6.tire-brand"),
        type: "select",
        selectList: this.tireBrandList,
        value: "",
        prop: "brand"
      },
      {
        label: t("v3_6_0.card-no"),
        type: "input",
        value: "",
        prop: this.appCode === "speedbiz" ? "warrantyCardCodes" : "warrantyCardNo"
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: t("v3_6_0.plate-no"),
              type: "input",
              value: "",
              prop: "plateCode"
            },
            {
              label: t("v3_6_0.customer-name"),
              type: "input",
              value: "",
              prop: "customerName"
            },
            {
              label: t("v3_6_0.customer-mobile"),
              type: "input",
              value: "",
              prop: "customerMobile"
            },
            {
              label: t("v3_6_0.customer-email"),
              type: "input",
              value: "",
              prop: "customerMail"
            }
          ]
        : []),
      {
        label: t("v3_7_3.registration-source"),
        type: "select",
        selectList: this.sourceList,
        value: "",
        prop: "warrantySource"
      },
      {
        label: t("v3_6_0.warranty-status"),
        type: "select",
        selectList: this.statusList,
        value: "",
        prop: this.appCode === "speedbiz" ? "statusList" : "status"
      }
    ].filter(item => item.if !== false);
  }
  created() {
    this.getDictionaryList("warranty_status").then(data => {
      this.statusList = data;
    });
    this.getDictionaryList("warranty_source").then(data => {
      this.sourceList = data;
    });
    this.getDictionaryList("tire_brand").then(data => {
      this.tireBrandList = data;
    });
    this.queryCountryInfoList({
      pageSize: 999
    }).then(data => {
      this.countryList = (data.data?.list || []).map(item => {
        item.label = item.countryName;
        item.value = item.countryCode;
        return item;
      });
    });
    this.loadListData();
  }
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "createTime") {
          this.searchForm.warrantyCardGenerateTimeBegin = item.value ? item.value[0] : "";
          this.searchForm.warrantyCardGenerateTimeEnd = item.value ? item.value[1] : "";
        } else if (item.prop === "purchaseTime") {
          this.searchForm.warrantyStartTimeBegin = item.value ? item.value[0] : "";
          this.searchForm.warrantyStartTimeEnd = item.value ? item.value[1] : "";
        } else if (item.prop === "statusList" || item.prop === "warrantyCardCodes") {
          this.searchForm[item.prop] = item.value ? [item.value] : [];
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  async sendEmail(warrantyCardNo) {
    await this.restSendEmail({
      warrantyCardNo
    });
    this.$message.success(t("v3_6_0.sent-success") as string);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryRecordList({
      ...this.searchForm,
      // orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.recordList = data.data.list;
      return data;
    });
  }
  preview(warrantyCardNo, index) {
    const imageRef: any = this.$refs[`previewImg${warrantyCardNo}${index}`][0];
    if (imageRef) {
      imageRef.clickHandler(index);
    }
  }
  previewMileageImg() {
    (this.$refs.previewMileageImg as any).clickHandler();
  }
  handleExportData() {
    const pathMap = {
      speedbiz: "/warranty/card/queryList/download",
      "speedbiz-operation": "/op/warranty/card/queryList/download"
    };
    formDownload(`${window.API_URL}${pathMap[this.appCode]}`, this.searchForm);
  }
  countryList: any = [];
  tireBrandList = [];
}
